import React from 'react';
import {
  Badge,
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@ais-ui/ui-core';
import { FilterTrigger } from '../../components/FilterTrigger';
import { ReplayVideoFilters } from './useReplayVideoFilters';

interface ReplayVideoFilterProps {
  filters: ReplayVideoFilters;
  setFilters: React.Dispatch<React.SetStateAction<ReplayVideoFilters>>;
}

export const ReplayVideoFilter = ({
  filters,
  setFilters,
}: ReplayVideoFilterProps) => {
  const getActiveFiltersCount = () => {
    let count = 0;
    if (filters.status !== 'all') count++;
    return count;
  };

  const activeFiltersCount = getActiveFiltersCount();

  return (
    <DropdownMenu>
      <Tooltip>
        <DropdownMenuTrigger asChild>
          <TooltipTrigger asChild>
            <FilterTrigger activeFilterCount={activeFiltersCount} />
          </TooltipTrigger>
        </DropdownMenuTrigger>
        <TooltipContent>
          {activeFiltersCount > 0
            ? `Filter replays (${activeFiltersCount} active)`
            : 'Filter replays'}
        </TooltipContent>
      </Tooltip>
      <DropdownMenuContent align="end" className="w-64 p-4 space-y-4">
        <div className="flex items-center justify-between">
          <div className="font-semibold text-sm">Filter Replays</div>
          {activeFiltersCount > 0 && (
            <Badge variant="secondary" className="text-xs">
              {activeFiltersCount} active
            </Badge>
          )}
        </div>

        {/* Status Filter */}
        <div className="space-y-2">
          <div className="text-sm font-medium">Status</div>
          <Select
            value={filters.status}
            onValueChange={(value) =>
              setFilters((prev) => ({
                ...prev,
                status: value as ReplayVideoFilters['status'],
              }))
            }
          >
            <SelectTrigger>
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">All Status</SelectItem>
              <SelectItem value="executing">Executing</SelectItem>
              <SelectItem value="pending">Pending</SelectItem>
              <SelectItem value="finished">Finished</SelectItem>
              <SelectItem value="failed">Failed</SelectItem>
              <SelectItem value="aborted">Aborted</SelectItem>
            </SelectContent>
          </Select>
        </div>

        {/* Clear Filters Button */}
        <div className="pt-2 border-t">
          <Button
            variant="outline"
            size="sm"
            className="w-full"
            onClick={() =>
              setFilters({
                status: 'all',
              })
            }
            disabled={activeFiltersCount === 0}
          >
            Clear Filters
          </Button>
        </div>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
